module.exports = __webpack_public_path__ + "static/img/2.6b9ec89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/document/1/2.png
// module id = V7Af
// module chunks = 1